import { useModelService } from "@shared/services/api/hooks/useModelService";
import PublicBasedProductCategoryRepository from "../repositories/PublicBasedProductCategoryRepository";

const productCategoryRepo = new PublicBasedProductCategoryRepository();

const usePublicProductCategoryService = () => {
  const { useList, useRetrieve, useGenericMutation, useGenericQuery } =
    useModelService(productCategoryRepo);

  return {
    useList,
    useRetrieve,
    useGenericMutation,
    useGenericQuery,
  };
};

export default usePublicProductCategoryService;
